import Send from '@/config/api/index'

const prometheusPath = "/v1/prometheus"

function prometheusApi(api, params) {
    return Send.post(prometheusPath + api, params)
}

export default {
    getNodeMetrics(params) {
        return prometheusApi('/node/all', params)
    }
}